import { render, staticRenderFns } from "./groupPermitsAziende.vue?vue&type=template&id=f4030f5e&scoped=true&"
import script from "./groupPermitsAziende.vue?vue&type=script&lang=js&"
export * from "./groupPermitsAziende.vue?vue&type=script&lang=js&"
import style0 from "./groupPermitsAziende.vue?vue&type=style&index=0&id=f4030f5e&scoped=true&lang=css&"
import style1 from "./groupPermitsAziende.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4030f5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBottomSheet,VBtn,VCol,VImg,VListItem,VListItemTitle,VRow,VSheet,VTextField})
